import { isInputFieldElement } from '@aline/common';
import { Editor, Node } from 'slate';
import { Apollo } from 'src/gql/generated';

/**
 * The text a non-signature field shows in the document right now, from its
 * first placement, or null when the field is not placed or is a signature.
 */
export function getLiveNonSigFieldText(editor: Editor, fieldId: UUID): string | null {
  for (const [field] of Editor.nodes(editor, {
    at: [],
    match: node => isInputFieldElement(node) && node.fieldId === fieldId,
    voids: true,
  })) {
    if (!isInputFieldElement(field)) continue;
    if (field.variant === Apollo.FieldVariant.Signature) return null;
    return Node.string(field);
  }

  return null;
}
